import { Box, Typography } from '@mui/material';
import AgencyInfo from '../../features/agencyInfo/components/AgencyInfo';

const AgencyInfoPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="xxl">Settings</Typography>
      <AgencyInfo />
    </Box>
  );
};

export default AgencyInfoPage;
